import React from 'react';
import { Alert } from 'antd';
import { AlertProps as AlertCopyProps } from 'antd/lib/alert';

export type AlertProps = AlertCopyProps;

const ProAlert: React.FC<AlertProps> = (props) => {
  return (
    <Alert { ...props } />
  );
}

export default ProAlert;